import { render, staticRenderFns } from "./warehouse-mass-confirm-changer.vue?vue&type=template&id=0800b537&scoped=true"
import script from "./warehouse-mass-confirm-changer.vue?vue&type=script&lang=js"
export * from "./warehouse-mass-confirm-changer.vue?vue&type=script&lang=js"
import style0 from "./warehouse-mass-confirm-changer.vue?vue&type=style&index=0&id=0800b537&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0800b537",
  null
  
)

export default component.exports